import { BaseComponent } from '../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { OutgoingModalWrapper } from './OutgoingModalWrapper';
import { SelectClientToOrder } from '../../components/AddToOrderModals/SelectClient/SelectClientToOrderModal';
import { fetchVehicle, shareExcelVehicleData } from '../../actions';

const STATE = {
  showSelectClientModal: true,
  showOutgoingOrderModal: false,
};

const Container = styled.div`
  font-size: 14px;
`;

/* eslint-disable react/prefer-stateless-function */
class AddMultiVehiclesToOrderComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
      vehiclesToOrder: props.vehicleIds,
    });
  }

  componentDidMount() {
    this.props.vehicleIds.map(vehicleId => {
      this.props.fetch(vehicleId);
    });
  }

  resetCurrentVehicle(vehicleId) {
    this.setState(
      prev => {
        return {
          vehiclesToOrder: prev.vehiclesToOrder.filter(id => id !== vehicleId),
        };
      },
      () => {
        if (!this.state.vehiclesToOrder[0]) {
          this.props.sendAction('close');
        }
      },
    );
  }

  reset() {
    this.props.sendAction('close');
  }

  save() {
    return this.props.reset();
  }

  render() {
    if (!this.state.vehiclesToOrder[0]) return null;
    return (
      <Container>
        {this.state.showSelectClientModal && (
          <SelectClientToOrder
            reset={this.reset.bind(this)}
            onClose={() => this.setState({ showSelectClientModal: false })}
            onNextModal={() => this.setState({ showSelectClientModal: false, showOutgoingOrderModal: true })}
          />
        )}
        {this.state.vehiclesToOrder[0] && this.state.showOutgoingOrderModal && (
          <OutgoingModalWrapper
            key={this.state.vehiclesToOrder[0]}
            vehicleId={this.state.vehiclesToOrder[0]}
            reset={this.resetCurrentVehicle.bind(this)}
          />
        )}
      </Container>
    );
  }
}

AddMultiVehiclesToOrderComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,

    shareExcel(dto, callback) {
      dispatch(shareExcelVehicleData(dto, callback));
    },
    fetch(vehicleId) {
      dispatch(fetchVehicle(vehicleId));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const AddMultiVehiclesToOrder = compose(withConnect, withRouter, injectIntl)(AddMultiVehiclesToOrderComp);
